import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const VisionPage: React.FC = () => {
  const { isAuthenticated, loading, user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    console.log('🔍 VisionPage - Auth State:', { isAuthenticated, loading, user: user?.email })
    
    if (!loading) {
      console.log('✅ Loading finished, redirecting...')
      if (isAuthenticated) {
        console.log('🔐 User authenticated, redirecting to dashboard')
        navigate('/vision/dashboard', { replace: true })
      } else {
        console.log('🚫 User not authenticated, redirecting to login')
        navigate('/vision/login', { replace: true })
      }
    } else {
      console.log('⏳ Still loading authentication state...')
    }
  }, [isAuthenticated, loading, navigate, user])

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-orange-900 to-red-900 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg">Redirecionando...</p>
      </div>
    </div>
  )
}

export default VisionPage
